import { ActionForm } from "@/components/actions/ActionForm";
import { actionPriorityCodeDefault, actionStatusCodeDefault } from "@/lib/task-utils";
import { actionEditUrlBuilder } from "@/lib/url-builder";
import { formatDate } from "@/lib/string-utils";
import { Action, ActionService } from "@/services/ActionService";
import { useNavigate, useParams, useSearchParams } from "react-router";

const ActionEditPage: React.FC = () => {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const projectId = searchParams.get('projectid');
  const featureId = searchParams.get('featureId');
  const featureTypeId = searchParams.get('featureTypeId');
  const navigate = useNavigate();

  const createAction = (): Action => {
    const todayDate = new Date();
    const endDate = new Date(todayDate.setDate(todayDate.getDate() + 7));
    return new Action("", "", params.siteId!, featureTypeId ?? null, featureId ?? null, projectId ?? null, actionPriorityCodeDefault, actionStatusCodeDefault, formatDate(todayDate), formatDate(endDate), null, "");
  }

  return (
    <div className="container mx-auto p-4">
      <ActionForm 
        action={createAction()}
        primaryButtonText="Create Task"
        onSave={async (action: Action) => {
          const newAction = await ActionService.create(action);
          navigate(actionEditUrlBuilder(params.siteId!, newAction.id))
        }}
      />
    </div>
  );
};

export default ActionEditPage;
